import React, { useState } from 'react';
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const WheelTirePackageCard = ({
    packageData,
    enableUpgradeMode,
    isUpgradeMode
}) => {

    const {
        image_url1,
        tire_image,
        diameter,
        width,
        brand_desc,
        price,
        tire_size,
        tire_brand,
        tire_price,
        sku,
        tire_sku,
        tire_item_id,
        vendor_id,
        tire_vendor_id,
        product_name,
        wheel_quantity,
        tire_quantity,
        bolt_pattern_metric,
        wheel_offset
    } = packageData;

    const tire_product_name = `${tire_brand} ${tire_size}`;

    const [loader, setLoader] = useState(false);

    const navigate = useNavigate();

    const PACKAGE_QTY = 4;

    const package_price = packageData?.package_price?.toFixed(2);

    const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;

    const S3_URL =
        "https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/";

    const getImageSrc = (url) => {
        if (!url || url.trim() === "") {
            return "https://extremeperformance.com/images/no-image-found.png";
        }

        if (url.startsWith("images/") || url.startsWith("str/")) {
            return S3_URL + url;
        }

        return url;
    };

    const wheelImage = getImageSrc(image_url1);
    const tireImage = getImageSrc(tire_image);

    const safeImage =
        image_url1 &&
        !image_url1.includes("app.netsuite.com/core/media/media.nl")
            ? image_url1
            : "https://extremeperformance.com/images/no-image-found.png";

    // ==================== ADD PACKAGE TO CART ====================

    const addPackageToCart = async () => {

        setLoader(true);

        try {

            const cartItems =
                JSON.parse(localStorage.getItem('totalCartItems')) || {};

            const canAdd =
                checkStock(
                    cartItems,
                    sku,
                    PACKAGE_QTY,
                    wheel_quantity,
                    "Wheel"
                ) &&
                checkStock(
                    cartItems,
                    tire_item_id,
                    PACKAGE_QTY,
                    tire_quantity,
                    "Tire"
                );

            if (!canAdd) {
                setLoader(false);
                return;
            }

            // Add Wheel
            await addItem(
                sku,
                price,
                PACKAGE_QTY,
                "wheel",
                safeImage,
                vendor_id,
                wheel_quantity,
                product_name
            );

            // Add Tire
            await addItem(
                tire_item_id,
                tire_price,
                PACKAGE_QTY,
                "tires_cat",
                tireImage,
                tire_vendor_id,
                tire_quantity,
                tire_product_name
            );

            window.dispatchEvent(new Event("cartUpdated"));

            toast.success("Package Added to cart successfully!", {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                theme: "colored",
            });

        } catch (error) {

            console.error(error);

            toast.error("Failed to add package to cart");

        } finally {

            setLoader(false);

        }
    };

    // ==================== STOCK CHECK ====================

    const checkStock = (
        cartItems,
        product_id,
        addingQty,
        availableStock,
        itemName
    ) => {

        const currentQty = cartItems[product_id] || 0;

        const newTotal = currentQty + addingQty;

        if (newTotal > availableStock) {

            toast.info(
                `Cannot add more ${itemName}. Only ${availableStock} available in stock!`,
                {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "colored",
                }
            );

            return false;
        }

        return true;
    };

    // ==================== ADD SINGLE ITEM ====================

    const addItem = async (
        product_id,
        product_price,
        quantity,
        category_type,
        image,
        vendor_id,
        total_quantity,
        product_name
    ) => {

        const cartItems =
            JSON.parse(localStorage.getItem('totalCartItems')) || {};

        const config = {
            method: 'post',
            url: `${mainUrl}/api/add-to-cart`,
            withCredentials: true,

            params: {
                product_image: image,
                product_id: product_id,
                product_name: product_name,
                product_price: product_price,
                product_quantity: quantity,
                category_type: category_type,
                total_quantity: total_quantity,
                part_number: product_id,
                vendor_id: vendor_id || ''
            },

            data: {
                cart_key: localStorage.getItem("cart-key") || '',
                user_token: localStorage.getItem("user-token") || ''
            }
        };

        const response = await axios.request(config);

        const existing = cartItems[product_id] || 0;

        cartItems[product_id] = existing + quantity;

        if (response.data.addCartResponse) {
            localStorage.setItem(
                "cart-key",
                response.data.addCartResponse
            );
        }

        localStorage.setItem(
            'totalCartItems',
            JSON.stringify(cartItems)
        );
    };

    // ==================== DETAILS PAGE ====================

    // const goToWheelDetails = () => {
    //     navigate(`/wheels-product-details/${sku}`);
    // };

    // const goToTireDetails = () => {
    //     navigate(`/tires-details/${tire_item_id}`);
    // };

      const goToWheelDetails = () => {
        window.open(`/wheels-product-details/${sku}`, "_blank");
    };

     const goToTireDetails = () => {
        window.open(`/tires-details/${tire_item_id}`, "_blank");
    };

    return (

    <div className="bg-white border rounded-4 shadow-sm overflow-hidden h-100">

    {/* TOP IMAGE SECTION */}

    <div className="row">

        {/* WHEEL IMAGE */}
        <div className="col-6 border-end text-center p-3">

            {/* <div className="small text-muted fw-bold mb-2">
                WHEEL
            </div> */}

            <img
                src={wheelImage}
                alt="wheel"
                onClick={goToWheelDetails}
                style={{
                    height: "140px",
                    objectFit: "contain",
                    cursor: "pointer"
                }}
                className="img-fluid"
            />

        </div>

        {/* TIRE IMAGE */}
        <div className="col-6 text-center p-3">

            {/* <div className="small text-muted fw-bold mb-2">
                TIRE
            </div> */}

            <img
                src={tireImage}
                alt="tire"
                onClick={goToTireDetails}
                style={{
                    height: "140px",
                    objectFit: "contain",
                    cursor: "pointer"
                }}
                className="img-fluid"
            />

        </div>

    </div>

    

    {/* PRODUCT DETAILS */}

    <div className="p-3">

        <div className="row">

            {/* WHEEL DETAILS */}
            <div className="col-6 border-end">

                <h6 className="fw-bold mb-2">
                    {brand_desc}
                </h6>

                <p className="small mb-1">
                    <strong>Size:</strong>{" "}
                    {diameter
                        ? Number(diameter).toFixed(0)
                        : ""}
                    x
                    {width}
                </p>

                <p className="small mb-1">
                    <strong>Offset:</strong> {wheel_offset}
                </p>

                {/* <p className="small mb-1">
                    <strong>Lug Pattern:</strong> {bolt_pattern_metric}
                </p> */}

                <p className="small mb-1">
                    <strong>SKU:</strong> {sku}
                </p>

                <p className="small mb-0 text-danger fw-bold">
                    ${parseFloat(price).toFixed(2)} 
                    <span className="text-dark fw-normal">
                        {" "}<strong>(each)</strong>
                    </span>
                </p>

            </div>

            {/* TIRE DETAILS */}
            <div className="col-6">

                <h6 className="fw-bold mb-2">
                    {tire_brand}
                </h6>

                <p className="small mb-1">
                    <strong>Size:</strong> {tire_size}
                </p>

                <p className="small mb-1">
                    <strong>SKU:</strong> {tire_sku}
                </p>

                <p className="small mb-0 text-danger fw-bold">
                    ${parseFloat(tire_price).toFixed(2)} 
                    <span className="text-dark fw-normal">
                        {" "}<strong>(each)</strong>
                    </span>
                </p>

            </div>

        </div>

        {/* PACKAGE PRICE */}

        {!isUpgradeMode && (
            <div className="text-center mt-2">
                <div className="fw-bold fs-5 text-danger">
                    Package Price ${Number(package_price || 0).toFixed(2)}
                </div>
            </div>
        )}

        {/* BUTTONS */}

        <div className="d-grid gap-2 mt-4">

            {!isUpgradeMode ? (

                <button
                    className="btn btn-outline-dark rounded-pill fw-bold"
                    onClick={() => enableUpgradeMode(packageData)}
                >
                    Upgrade Tire Option
                </button>

            ) : (

                <div className="text-center fw-bold text-danger fs-5">
                    Package Price:
                    ${package_price || '0.00'}
                </div>

            )}

            {!loader ? (

                <button
                    onClick={addPackageToCart}
                    className="btn btn-danger rounded-pill fw-bold"
                >
                     Add Package To Cart
                </button>

            ) : (

                <button
                    disabled
                    className="btn btn-secondary rounded-pill fw-bold"
                >
                    Loading...
                </button>

            )}

        </div>

    </div>

</div>


    );
};

export default WheelTirePackageCard;















// import React, { useState } from 'react';
// import axios from "axios";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// const WheelTirePackageCard = ({ packageData, enableUpgradeMode, isUpgradeMode }) => {

//   const { image_url1, tire_image, diameter, width, brand_desc, price, tire_size, tire_brand, 
//     tire_price, sku, tire_sku, tire_item_id, vendor_id, tire_vendor_id, 
//     product_name, wheel_quantity, tire_quantity } = packageData;
    

//     const tire_product_name = `${tire_brand} ${tire_size}`;
//     const [loader, setLoader] = useState(false);
//     const navigate = useNavigate();
//     const PACKAGE_QTY = 4;

//     const package_price = packageData?.package_price?.toFixed(2);
//     const mainUrl = process.env.REACT_APP_EXPRESS_APP_URL;
//     const S3_URL = "https://extremewheelsdevelopment.s3-accelerate.amazonaws.com/";

//     const getImageSrc = (url) => {
//         if (!url || url.trim() === "") {
//             return "https://extremeperformance.com/images/no-image-found.png";
//         }

//         if (url.startsWith("images/") || url.startsWith("str/")) {
//             return S3_URL + url;
//         }

//         return url;
//     };


// //     const getImageSrc = (url) => {
// //     const fallback =
// //         "https://extremeperformance.com/images/no-image-found.png";

// //     if (!url || url.trim() === "") {
// //         return fallback;
// //     }

// //     // Block NetSuite media URLs
// //     if (
// //         url.includes("app.netsuite.com/core/media/media.nl")
// //     ) {
// //         return fallback;
// //     }

// //     if (url.startsWith("images/") || url.startsWith("str/")) {
// //         return S3_URL + url;
// //     }

// //     return url;
// // };

//     const wheelImage = getImageSrc(image_url1);
//     const tireImage = getImageSrc(tire_image);

//     // for add to cart =========
//     const safeImage = image_url1 &&  !image_url1.includes("app.netsuite.com/core/media/media.nl") ? image_url1 : "https://extremeperformance.com/images/no-image-found.png";


//     // ==================== ADD PACKAGE TO CART ====================
//     const addPackageToCart = async () => {
//         setLoader(true);

//         try {
//             const cartItems = JSON.parse(localStorage.getItem('totalCartItems')) || {};
//             const canAdd = checkStock(cartItems, sku, PACKAGE_QTY, wheel_quantity, "Wheel") && checkStock(cartItems, tire_item_id, PACKAGE_QTY, tire_quantity, "Tire");

            
//             if (!canAdd) {
//                 setLoader(false);
//                 return;
//             }

//             // Add Wheel
//            await addItem(sku, price, PACKAGE_QTY, "wheel", safeImage, vendor_id, wheel_quantity, product_name);
//             // Add Tire
//            await addItem(tire_item_id, tire_price, PACKAGE_QTY, "tires_cat", tireImage, tire_vendor_id, tire_quantity, tire_product_name);

//             window.dispatchEvent(new Event("cartUpdated"));

//             toast.success("Package Added to cart successfully!", {
//                 position: "top-center",
//                 autoClose: 5000,
//                 hideProgressBar: true,
//                 closeOnClick: true,
//                 pauseOnHover: true,
//                 draggable: true,
//                 theme: "colored",
//             });

//         } catch (error) {
//             console.error(error);
//             toast.error("Failed to add package to cart");
//         } finally {
//             setLoader(false);
//         }
//     };

//     // ==================== STOCK CHECK ====================
//  const checkStock = (cartItems, product_id, addingQty, availableStock, itemName) => {

//         const currentQty = cartItems[product_id] || 0;
//         const newTotal = currentQty + addingQty;
        
//         if (newTotal > availableStock) {
//             toast.info(
//                 `Cannot add more ${itemName}. Only ${availableStock} available in stock!`,
//                 {
//                     position: "top-center",
//                     autoClose: 5000,
//                     hideProgressBar: true,
//                     closeOnClick: true,
//                     pauseOnHover: true,
//                     draggable: true,
//                     theme: "colored",
//                 }
//             );
//             return false;
//         }
//         return true;
//     };

//     // ==================== ADD SINGLE ITEM ====================
//    const addItem = async (product_id, product_price, quantity, category_type, image, vendor_id, total_quantity, product_name) => {

//         const cartItems = JSON.parse(localStorage.getItem('totalCartItems')) || {};

//         const config = {
//             method: 'post',
//             url: `${mainUrl}/api/add-to-cart`,
//             withCredentials: true,

//             params: {
//                 product_image: image,
//                 product_id: product_id,
//                 product_name: product_name,
//                 product_price: product_price,
//                 product_quantity: quantity,
//                 category_type: category_type,
//                 total_quantity: total_quantity,
//                 part_number: product_id,
//                 vendor_id: vendor_id || ''
//             },

//             data: {
//                 cart_key: localStorage.getItem("cart-key") || '',
//                 user_token: localStorage.getItem("user-token") || ''
//             }
//         };

//         const response = await axios.request(config);
//         // Update local cart
//         const existing = cartItems[product_id] || 0;

//         cartItems[product_id] = existing + quantity;

//         if (response.data.addCartResponse) {
//             localStorage.setItem("cart-key", response.data.addCartResponse);
//         }
//         localStorage.setItem('totalCartItems', JSON.stringify(cartItems));
//     };

//     // ==================== DETAILS PAGE ====================
//     const goToWheelDetails = () => {
//         navigate(`/wheels-product-details/${sku}`);
//     };

//     const goToTireDetails = () => {
//         navigate(`/tires-details/${tire_item_id}`);
//     };



//     return (
//         <div className="package-card border bg-white p-3 h-100">

//             <div className="row g-3">

//                 {/* Wheel */}
//                 <div className="col-6 text-start">

//                     <img
//                         src={wheelImage}
//                         alt="wheel"
//                         style={{
//                             height: "130px",
//                             objectFit: "contain",
//                             cursor: "pointer"
//                         }}
//                         className="mb-2"
//                         onClick={goToWheelDetails}
//                     />

//                     <h6>
//                         <strong>
//                             Wheel Size:
//                             {diameter
//                                 ? Number(diameter).toFixed(0)
//                                 : ""}x
//                             {width && !isNaN(Number(width))
//                                 ? width
//                                 : ""}
//                         </strong>
//                     </h6>

//                     <p className="small mb-1">
//                         <strong>SKU:</strong> {sku}
//                     </p>

//                     <p className="small">
//                         <strong>Brand:</strong> {brand_desc}
//                     </p>

//                     <p className="small">
//                         <strong>
//                             Price:
//                             <span className="text-danger">
//                                 ${parseFloat(price).toFixed(2)}
//                             </span>
//                             (Each)
//                         </strong>
//                     </p>

//                     <p className="small">
//                         <strong>
//                             Set of 4:
//                             <span className="text-danger">
//                                 ${(price * 4).toFixed(2)}
//                             </span>
//                         </strong>
//                     </p>
//                 </div>

//                 {/* Tire */}
//                 <div className="col-6 text-start">

//                     <img
//                         src={tireImage}
//                         alt="tire"
//                         style={{
//                             height: "130px",
//                             objectFit: "contain",
//                             cursor: "pointer"
//                         }}
//                         className="mb-2"
//                         onClick={goToTireDetails}
//                     />

//                     <h6>
//                         <strong>
//                             Tire Size: {tire_size}
//                         </strong>
//                     </h6>

//                     <p className="small mb-1">
//                         <strong>SKU:</strong> {tire_sku}
//                     </p>

//                     <p className="small">
//                         <strong>Brand:</strong> {tire_brand}
//                     </p>

//                     <p className="small">
//                         <strong>
//                             Price:
//                             <span className="text-danger">
//                                 ${tire_price}
//                             </span>
//                             (Each)
//                         </strong>
//                     </p>

//                     <p className="small">
//                         <strong>
//                             Set of 4:
//                             <span className="text-danger">
//                                 ${(tire_price * 4).toFixed(2)}
//                             </span>
//                         </strong>
//                     </p>
//                 </div>
//             </div>

//             {!isUpgradeMode && (
//                 <div className="text-center my-3">
//                     <h6 className="text-danger fw-bold">
//                         Package Price : $
//                         {package_price ? package_price : '0.00'}
//                     </h6>
//                 </div>
//             )}

//             <div className="d-flex flex-column flex-sm-row gap-2 justify-content-between border-top py-2">

//                 {!isUpgradeMode ? (
//                     <button
//                         className="btn btn-secondary"
//                         onClick={() => enableUpgradeMode(packageData)}
//                     >
//                         Upgrade Tire Option For This Wheel
//                     </button>
//                 ) : (
//                     <div className="fw-bold text-danger fs-5 text-center">
//                         Package Price: $
//                         {package_price ? package_price : '0.00'}
//                     </div>
//                 )}

//                 {!loader ? (
//                     <button
//                         onClick={addPackageToCart}
//                         className="package-cart"
//                     >
//                         Add to Cart
//                     </button>
//                 ) : (
//                     <button
//                         disabled
//                         className="btn btn-secondary"
//                     >
//                         Loading...
//                     </button>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default WheelTirePackageCard;
